import { ThemeView, ThemePressable, View, Pressable } from '@/components/Theme';
import isEqual from "lodash/isEqual";
import { memo, useMemo } from "react";
import { StyleSheet } from "react-native";
import ListItemImage from "./Image";
import ListItemText from "./Text";
import { IconButton, IconBgButton } from "@/components/Buttons";
import { VIEW_BORDER_RADIUS } from "@/constants/Styles";
import colors from "@/constants/Colors";
import { useThemeColor } from "@/hooks/useThemeColor";

const ListItem = (props) => {

    const {
        item = {},
        size='md',
        style = {},
        imageStyle={},
        BadgeComponent = null,
        onPress = null,
        children = null,
        light = null,
        dark = null,
        icon = null,
        iconColor = undefined,
        iconProps = {},
        themed = true,
        isActive = false,
        append = null,
        prepend = null,
        ...rest
    } = props;

    const {
        image,
        forceImage = false 
    } = item;

    const {
        position: iconPosition = 'left',
        ...iconPropsRest
    } = iconProps;

    const WrapperComp = useMemo(() => {
        const isPressable = onPress ? true : false;

        if (isPressable)
            return (themed) ? ThemePressable : Pressable;
        
        return (themed) ? ThemeView : View;

    }, [themed, onPress]);

    const activeStyle = isActive ? {borderWidth: 2, borderColor: colors.lime[500]} : null;

    const themedProps = useMemo(() => {

        if (themed) {
            return {
                light: light ?? 'muted.100',
                dark: dark ?? 'muted.800',
                rounded: true
            }
        }

        return {};
    }, [themed, light, dark]);

    const iconThemeColor = useThemeColor({
        light: iconProps?.backgroundColor ?? iconProps?.light ?? colors.muted[200], 
        dark: iconProps?.backgroundColor ?? iconProps?.dark ?? colors.muted[700]
    });
    
    return (
        <WrapperComp {...rest} {...themedProps} style={[styles.wrapper, style, activeStyle]} onPress={onPress}>
            {prepend != null && (
                typeof prepend == 'function' ? prepend() : prepend
            )}
            
            {icon && iconPosition == 'left' &&
                <View style={styles.leftItem}>
                    <IconBgButton bg={iconThemeColor} padding={12} icon={icon} color={iconColor} size={20} {...iconPropsRest} />
                </View> 
            }

            {(image || forceImage) &&
                <View style={styles.leftItem}>
                    <ListItemImage forceImage={forceImage} item={item} size={size} style={imageStyle} />
                    {BadgeComponent && <BadgeComponent />}
                </View> 
            }
            
            <ListItemText {...rest} {...item} themed={themed}>
                {children}
            </ListItemText>


            {icon && iconPosition == 'right' &&
                <View style={styles.leftItem}>
                    <IconButton icon={icon} color={iconColor} {...iconPropsRest} />
                </View> 
            }
            
            {append != null && (
                typeof append == 'function' ? append() : append
            )}
            
        </WrapperComp>
    );
};

const styles = StyleSheet.create({
    wrapper: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: 15,
        padding: 10,
        borderRadius: VIEW_BORDER_RADIUS,
    },
    pretitle: {},
    title: {
        flexGrow: 1,
        flex: 1,
    },
    subtitle: {},
    image: {
        borderRadius: 100,
    },
    leftItem: {
    },
});

export default memo(ListItem, isEqual);